import { Navigate, Outlet } from 'react-router-dom';
import { Authentication } from './service/auth.utils'

const ProtectedRoute = () => {
  const tokenAuthentication = new Authentication();
  const isAuthenticated = tokenAuthentication.isAuthenticated();

  return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default ProtectedRoute;
